import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import Confirmpassword from "./Confirmpassword";
import Otp from "./Otp";
import { forgetpassword } from "../../api/endpoints";
import ForgetPassword from "./ForgetPasswords";
function Forgetpassword({ onClose ,login , setLogin}) {
  const isModel = useSelector((state) => state?.auth?.forgetpass)
    return (
        <>
           {!!isModel?.email ?<ForgetPassword  onClose={onClose}  setLogin={setLogin} login={login}/> :<></>}
            {/* enter otp */}
            {/* {!!isModel?.otp ? <Otp/> :<></>} */}
            {/*  */}
            {/* confirm password */}
            {/* <Confirmpassword/> */}
        </>
    )
}

export default Forgetpassword